import './main-menu-profile-item.component.scss';

import DefaultImage from "/assets/img/ic_no_avatar.svg";

export default {
  template: require('./main-menu-profile-item.component.html'),
  bindings: {
    onSubmitContactUs: "<vuiSubmitContactUs",
    profileLink: "@?vuiProfileLink"
  },
  controller: function ($routeParams, $t, $gl, $alert, $auth, vuiModals) {
    'ngInject';

    const self = this;

    self.auth = $auth;
    self.actions = {};

    self.signOut = () => {
      self.actions.close();
      $auth.logout();
    }

    self.onSelect = () => {
      self.actions.close();
    }

    self.getFullName = () => {
      if ($auth.user()) {
        return $auth.user().name + ' ' + $auth.user().surname;
      } else {
        return ''
      }
    }

    self.getAvatar = () => {
      if ($auth.user() && $auth.user().avatar) {
        return $auth.user().avatar.thumbnail
      } else {
        return DefaultImage
      }
    };

    self.contactUs = () => {
      self.actions.close();
      vuiModals.contactUs(result => {
        if (result) {
          self.onSubmitContactUs(result);
        }
      })
    }

  }
};
